"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/patientResponse/MessageActions.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactdom = require('react-dom');

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);


// The six reactions a patient may add: the provider picker's quick
// reactions, the only ones the link socket accepts.
 const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🎉'] 



; exports.QUICK_REACTIONS = QUICK_REACTIONS

 const actionsVariant = () =>
  _optionalChain([window, 'access', _ => _.matchMedia, 'optionalCall', _2 => _2('(hover: hover) and (pointer: fine)'), 'access', _3 => _3.matches]) ? 'popover' : 'sheet'; exports.actionsVariant = actionsVariant

















const POPOVER_GAP_PX = 6
const VIEWPORT_MARGIN_PX = 8

const ReactionButton = ({ emoji, mine, onReact }) => {
  const react = _react.useCallback.call(void 0, () => onReact(emoji), [onReact, emoji])
  return (
    _react2.default.createElement('button', {
      type: "button",
      className: _classBuilder2.default.call(void 0, 'message-actions--reaction', mine && 'message-actions--reaction-mine'),
      'aria-label': mine ? `Remove your ${emoji} reaction` : `React with ${emoji}`,
      'aria-pressed': mine,
      onClick: react, __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}

      ,  emoji 
    )
  )
}

const MessageActions = ({
  variant, anchor, senderName, text, reactions, reactionsOnly, onReact, onReply, onCopy, onClose,
}) => {
  const panelRef = _react.useRef(null)
  const [position, setPosition] = _react.useState(undefined)

  // The popover sits under its control, or above it when the window has no
  // room below, and never past the window's edges.
  _react.useLayoutEffect.call(void 0, () => {
    if (variant !== 'popover' || !anchor || !panelRef.current) return
    const from = anchor.getBoundingClientRect()
    const panel = panelRef.current.getBoundingClientRect()
    const below = from.bottom + POPOVER_GAP_PX
    const top = below + panel.height > window.innerHeight - VIEWPORT_MARGIN_PX
      ? Math.max(VIEWPORT_MARGIN_PX, from.top - POPOVER_GAP_PX - panel.height)
      : below
    const left = Math.min(
      Math.max(VIEWPORT_MARGIN_PX, from.left),
      window.innerWidth - VIEWPORT_MARGIN_PX - panel.width,
    )
    setPosition({ top, left })
  }, [variant, anchor])

  // Focus moves into the actions and returns to the control on close,
  // unless the action moved it on (Reply puts it in the message box).
  _react.useEffect.call(void 0, () => {
    const panel = panelRef.current
    _optionalChain([panel, 'optionalAccess', _4 => _4.querySelector, 'call', _5 => _5('button'), 'optionalAccess', _6 => _6.focus, 'call', _7 => _7()])
    return () => {
      const focused = document.activeElement
      if (!focused || focused === document.body || _optionalChain([panel, 'optionalAccess', _8 => _8.contains, 'call', _9 => _9(focused)])) _optionalChain([anchor, 'optionalAccess', _10 => _10.focus, 'call', _11 => _11()])
    }
  }, [anchor])

  const close = _react.useEffectEvent.call(void 0, () => onClose())
  _react.useEffect.call(void 0, () => {
    const onKey = (event) => { if (event.key === 'Escape') close() }
    // A press outside the popover closes it, as a click on the sheet's scrim does.
    const onPointer = (event) => {
      if (variant === 'popover' && !_optionalChain([panelRef, 'access', _12 => _12.current, 'optionalAccess', _13 => _13.contains, 'call', _14 => _14(event.target )]) && !_optionalChain([anchor, 'optionalAccess', _15 => _15.contains, 'call', _16 => _16(event.target )])) close()
    }
    document.addEventListener('keydown', onKey)
    document.addEventListener('pointerdown', onPointer)
    return () => {
      document.removeEventListener('keydown', onKey)
      document.removeEventListener('pointerdown', onPointer)
    }
  }, [variant, anchor])

  const mine = new Set()
  for (const reaction of _nullishCoalesce(reactions, () => ( []))) if (reaction.Mine) mine.add(reaction.Emoji)
  // The sheet covers the card the message is in.
  const target = _nullishCoalesce(_optionalChain([anchor, 'optionalAccess', _17 => _17.closest, 'call', _18 => _18('.patient-page--card')]), () => ( _optionalChain([anchor, 'optionalAccess', _19 => _19.ownerDocument, 'access', _20 => _20.body])))

  const panel = (
    _react2.default.createElement('div', {
      ref: panelRef,
      className: _classBuilder2.default.call(void 0, 'message-actions', `message-actions--${variant}`),
      role: "dialog",
      'aria-label': "Message actions" ,
      // Until it is placed it is drawn transparent, not hidden, so focus can move into it.
      style: variant === 'popover' ? _nullishCoalesce(position, () => ( { opacity: 0, pointerEvents: 'none' })) : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}}

      ,  variant === 'sheet' && (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement('div', { className: "message-actions--grab", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}} )
          , _react2.default.createElement('p', { className: "message-actions--quote", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}
            ,  senderName && _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 119}},  senderName , ": " ) 
            ,  text 
          )
        )
      )
      , _react2.default.createElement('div', { className: "message-actions--reactions", role: "group", 'aria-label': "Reactions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
        ,  exports.QUICK_REACTIONS.map(emoji => (
          _react2.default.createElement(ReactionButton, { key: emoji, emoji: emoji, mine: mine.has(emoji), onReact: onReact, __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}} )
        )) 
      )
      ,  !reactionsOnly && (onReply || onCopy) && (
        _react2.default.createElement('div', { className: "message-actions--items", __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}
          ,  onReply && (
            _react2.default.createElement('button', { type: "button", className: "message-actions--item", onClick: onReply, __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
              , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}, "reply"), "Reply"

            )
          )
          ,  onCopy && (
            _react2.default.createElement('button', { type: "button", className: "message-actions--item", onClick: onCopy, __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}
              , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}, "content_copy"), "Copy text"

            )
          )
        )
      )
    )
  )

  if (!target) return null

  return _reactdom.createPortal.call(void 0, 
    variant === 'sheet'
      ? (
          _react2.default.createElement('div', { className: "message-actions--layer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}
            , _react2.default.createElement('div', { className: "message-actions--scrim", onClick: onClose, 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}} )
            ,  panel 
          )
        )
      : panel,
    target,
  )
}

exports. default = MessageActions
